import mm from './dist/index-es'
export default mm;